<button 
    [type]="type" 
    [disabled]="disabled" 
    [ngClass]="{'opacity-30' : isProcessing, 'opacity-10 cursor-not-allowed' : disabled}" 
    [class]="'text-white bg-[var(--red)] text-[13px] uppercase font-bold px-[27px] py-[12px] rounded-[10px] hover:bg-[var(--red-hover)] transition-all w-full ' + (style + '-style') + ' ' + classList ">
    <ng-content *ngIf="!isProcessing"></ng-content>
    <div *ngIf="isProcessing" id="spinner-holder">
        <app-spinner />
    </div>
</button>